import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHubMain4 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M7 16V8.4L2 3.4V6H0V0H6V2H3.4L9 7.6V16H7ZM10.85 6.6L9.4 5.15L12.6 2H10V0H16V6H14V3.4L10.85 6.6Z",
		fill: "#9B2C2C"
	})]
});
const ForwardRef = forwardRef(SvgHubMain4);
export { ForwardRef as ReactComponent };
